import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly authStorageKey = 'angular-demo-auth';
  private readonly validEmail = 'demo-email@gmail.com';
  private readonly validPassword = 'password123';

  login(email: string, password: string): boolean {
    const canLogin = email === this.validEmail && password === this.validPassword;

    if (canLogin) {
      localStorage.setItem(
        this.authStorageKey,
        JSON.stringify({ isAuthenticated: true, email })
      );
    }

    return canLogin;
  }

  logout(): void {
    localStorage.removeItem(this.authStorageKey);
  }

  isAuthenticated(): boolean {
    const session = localStorage.getItem(this.authStorageKey);

    if (!session) {
      return false;
    }

    try {
      const parsed = JSON.parse(session) as { isAuthenticated?: boolean };
      return parsed.isAuthenticated === true;
    } catch {
      return false;
    }
  }

  getDemoCredentials(): { email: string; password: string } {
    return {
      email: this.validEmail,
      password: this.validPassword
    };
  }
}